import React, { useEffect, useState } from 'react';
import { Box, Chip, CircularProgress, List, ListItem, ListItemText, Typography } from '@mui/material';
import orderPlanService, { OrderPlanItem } from '../../services/orderPlanService';

interface Props { projectId: string }

const MobileOrderPlanList: React.FC<Props> = ({ projectId }) => {
  const [items, setItems] = useState<OrderPlanItem[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      try {
        setLoading(true);
        const data = await orderPlanService.list(projectId);
        if (mounted) setItems(data);
      } finally {
        if (mounted) setLoading(false);
      }
    };
    load();
    return () => { mounted = false; };
  }, [projectId]);

  if (loading) {
    return <Box sx={{ py: 2, textAlign: 'center' }}><CircularProgress size={20} /></Box>;
  }

  return (
    <List sx={{ px: 0 }}>
      {items.map((it) => (
        <ListItem key={it.id} sx={{ alignItems: 'flex-start', px: 0 }}>
          <ListItemText
            primary={
              <Box sx={{ display:'grid', gridTemplateColumns:'auto 1fr', columnGap: 1, width: '100%' }}>
                <Typography variant="subtitle2" sx={{ alignSelf:'center' }}>#{it.sequence_number}</Typography>
                <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>{it.description}</Typography>
              </Box>
            }
            secondary={
              <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0,1fr))', rowGap: 0.5, columnGap: 2, mt: 0.5 }}>
                <Typography variant="caption">Czas realizacji: {it.lead_time_days ?? '-'} dni</Typography>
                <Typography variant="caption">Deadline: {it.deadline_date || '-'}</Typography>
                <Typography variant="caption">Termin dostawy: {it.delivery_date || '-'}</Typography>
                <Typography variant="caption">Pozostało: {it.remaining_days ?? '-'} dni</Typography>
                <Typography variant="caption">Status: {it.status}</Typography>
                <Typography variant="caption">Termin zamówienia: {it.order_date || '-'}</Typography>
              </Box>
            }
          />
        </ListItem>
      ))}
      {items.length === 0 && (
        <Typography variant="body2" color="text.secondary" sx={{ px:2, py:1 }}>Brak pozycji planu zamówień.</Typography>
      )}
    </List>
  );
};

export default MobileOrderPlanList;


